/*
 * @Author: wanglibo
 * @LastEditors: wanglibo
 * @Description: 
 */
// const ajax=require('./ajax');
// import {ajax} from './ajax';
import ajax from './ajax';
import axios from 'axios';
class ClinicApi {
	// 生成记录id
	generateId() {
		return ajax.Post({
			url: '/api/loss/patientNutritionClinicRecord/generateId'
		});
	}
	// 保存营养门诊筛查和评估记录
	addNrsAndAssessmentRecord = (data) => {
		return ajax.Post({
			url: `/api/loss/patientNutritionClinicRecord/addNrsAndAssessmentRecord`,
			data
		});
	};
	// 查询营养门诊筛查和评估详情
	searchLifeStyleRecordById = (data) => {
		return ajax.Post({
			url: `/api/loss/patientNutritionClinicRecord/searchLifeStyleRecordById`,
			data
		});
	};
	// 保存营养门诊生活方式调查记录
	addPatientLifeStyleAssessmentRecord = (data) => {
		return ajax.Post({
			url: `/api/loss/patientNutritionClinicRecord/addPatientLifeStyleAssessmentRecord`,
			data
		});
	};
	// 查询营养门诊生活方式调查记录详情
	searchNrsAndAssessmentRecordById = (data) => {
		return ajax.Post({
			url: `/api/loss/patientNutritionClinicRecord/searchNrsAndAssessmentRecordById`,
			data
		});
	};
	// 查询过往病史字典
	selectPastMedicalDict = () => {
		return ajax.Post({
			url: `/api/loss/patientNutritionClinicRecord/selectPastMedicalDict`,
			data:{}
		});
	};
	// 上传文件
	uploadFile = (formData,cb) => {
		return axios.post(`/api/loss/file/uploadFile`, formData, {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			})
			.then((res) => {
				if(res.status===200){
					let response=JSON.parse(res.request.response)
					cb(response)
				}
				console.log('上传成功', res);
			})
			.catch((err) => {
				console.log('上传失败', err);
			});
	};
}
export default new ClinicApi();
